import { useState, useEffect } from "react";
import { useGame } from "../../context/GameContext.jsx";

export function DraggablePlayerList({ players, renderRow }) {
  const { dispatch } = useGame();
  const [dragId, setDragId] = useState(null);
  const [list, setList] = useState(players);

  useEffect(() => { setList(players); }, [players]);

  const onDragStart = (id) => setDragId(id);
  const onDragOver = (e, overId) => {
    e.preventDefault();
    if (overId === dragId) return;
    const from = list.findIndex(p => p.id === dragId);
    const to   = list.findIndex(p => p.id === overId);
    if (from === -1 || to === -1) return;
    const next = [...list];
    next.splice(to, 0, next.splice(from, 1)[0]);
    setList(next);
  };
  const onDrop = () => {
    dispatch({ type: "REORDER_PLAYERS", payload: list });
    setDragId(null);
  };

  return (
    <div className="flex flex-col gap-2">
      {list.map(p => (
        <div key={p.id}
          draggable
          onDragStart={() => onDragStart(p.id)}
          onDragOver={(e) => onDragOver(e, p.id)}
          onDrop={onDrop}
          className={`flex items-center gap-2 transition-opacity ${dragId === p.id ? "opacity-40" : ""}`}>
          <span className="text-amber-800/60 text-lg px-1 cursor-grab active:cursor-grabbing select-none">≡</span>
          <div className="flex-1">{renderRow(p)}</div>
        </div>
      ))}
    </div>
  );
}
